import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import medicareProLogo from '../../../../assets/logo_medicarepro.png';
import { baseStyleSheet } from '../../../../styles/styles';
import { GenericIntegrationGraphic } from '../../../svgs/graphics/GenericIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { medicareProColor, styleSheet } from './styles';

export const DashboardMedicareProIntegrationCard = () => {
	const userSession = useUserSession();
	const { getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } = useIntegrationCard({
		closeIntegrationEventName: 'MedicareProIntegrationClosed',
		enableUrlPath: `/integrations/${Api.IntegrationProvider.MedicarePro}`,
		integrationEnableEventName: 'MedicareProIntegrationEnableClick',
		pendingAction: Api.PendingActions.ConnectMedicarePro,
	});

	if (!showCard || !userSession.isAdmin) {
		return null;
	}

	return (
		<IntegrationCard
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={
				<>
					<img src={medicareProLogo} alt='MedicarePRO CRM Logo' className={css(styleSheet.graphic)} />
					<span className={css(styleSheet.integrationGraphic)}>
						<GenericIntegrationGraphic color={medicareProColor} />
					</span>
				</>
			}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect MedicarePRO CRM',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				children: 'Connect MedicarePRO CRM',
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>
				MedicarePRO CRM is enabled for your account and needs an API token to sync. Once connected, Levitate will pull
				client information, including names, email, phone numbers, policies, and more.
			</p>
			<p>If your MedicarePRO CRM sync was already set up, the token was rejected and a new one is needed.</p>
		</IntegrationCard>
	);
};
